import { useField } from "formik"
import { Typography } from "@mui/material"
import { LocalizedStrict } from "../../../../../../modules/localization/components/AppLocalized"
import { DeliveryTimesField, DynamicConfigKey } from "../../form/formTypes"
import { useResourceBookingDraftData } from "../../resource/ResourceBookingDraftContext"
import { MeetingServices } from "./MeetingServices"
import { CreateOrderType } from "../../../helpers"
import { CreateOrderDialogMode } from "../../../createOrderTypes"
import { Resources } from "./Resources"

type OrderSummaryProps = Readonly<{
    isRefundOrder: boolean
    isUpdatable: boolean
    orderType: CreateOrderType
    userId: number
    mode?: CreateOrderDialogMode
}>

export function OrderSummaryContent({ isRefundOrder, isUpdatable, orderType, userId, mode }: OrderSummaryProps) {
    const [{ value: deliveries }] = useField<DeliveryTimesField | undefined>(DynamicConfigKey.MULTIPLE_DELIVERIES)
    const { draftEvent } = useResourceBookingDraftData()

    const hasResources = !!draftEvent?.resourceIds?.length

    const hasMeetingServices = deliveries?.deliveryTimes
    const shouldShowEmptyState = !hasResources && !hasMeetingServices

    return (
        <>
            {hasResources && !isRefundOrder && <Resources isUpdatable={isUpdatable} />}
            {hasMeetingServices && (
                <MeetingServices
                    isRefundOrder={isRefundOrder}
                    isEditable={orderType === CreateOrderType.MEETING_SERVICE}
                    userId={userId}
                    mode={mode}
                />
            )}
            {shouldShowEmptyState && (
                <LocalizedStrict id="create-order-order-summary-no-items">
                    <Typography variant="body1">
                        Order summary is currently empty. Add items to your order to see the details.
                    </Typography>
                </LocalizedStrict>
            )}
        </>
    )
}
